module.exports = __webpack_public_path__ + "static/media/review.2808cc7b.png";